import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container p-4">
      <h1>Privacy Policy</h1>
      <p>
        Welcome to our Privacy Policy page. Your privacy is critically important to us. This document outlines how we collect, use, and protect your personal information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We collect personal information that you provide to us directly, such as when you create an account, place an order, or contact customer support. This may include your name, email address, phone number, and payment details.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information to provide and improve our services, process transactions, send notifications, and respond to your inquiries. We may also use your information for marketing purposes, but only with your consent.
      </p>

      <h2>3. Sharing Your Information</h2>
      <p>
        We do not sell or share your personal information with third parties, except as necessary to provide our services (e.g., payment processors) or as required by law.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You have the right to access, update, or delete your personal information. If you wish to exercise these rights, please contact us at support@platoo.com.
      </p>

      <h2>6. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review it periodically.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at support@platoo.com.
      </p>
    </div>
  );
};

export default PrivacyPolicy;